export default __webpack_public_path__ + "static/media/mole.5991b2d8.png";